// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-02-28 13:36:46 +0100 (Fri, 28 Feb 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 150691 $
// Purpose     : stats panels
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Table} from 'semantic-ui-react'

// ---Framework imports
import {get, isArray} from 'ldash'
import {Sel} from 'uix/registries'
import log from 'uix/logging'
import {usePhysicalNode, useSelector, useSummaries} from 'uix/hooks'
import {DashSegment} from 'uix/components/grid'
import {Link} from 'uix/components'
import {formatNumber} from 'uix/utils'
import {DatatypeDescription} from 'uix/types/components'

// ---Local imports
import {Plot} from './plots'

// ---Exports

const GrowthPlotPanel = ({plotName, height = 260}) => {
  if (isArray(plotName)) {
    return plotName.map(n => <Plot key={n} showLegend showMenu="basic" name={n} height={height} />)
  }
  return <Plot showLegend showMenu="basic" name={plotName} height={height} />
}

export const PlotPanel = {
  Comp: GrowthPlotPanel,
  datatypes: ['domain'],
}

const NodeOverviewPlot = ({height = 260}) => {
  let node = usePhysicalNode()
  let plotName = 'countMetadata' // if domain
  return <Plot showLegend showMenu="basic" name={plotName} height={height} />
}

export const NodeOverviewPanel = {
  Comp: NodeOverviewPlot,
  align: 'right',
  datatypes: ['domain'],
}

export const NodeStats = {
  Comp: ({i18n}) => {
    let itypes = useSelector(Sel.itypes)
    let {dname} = useSelector(Sel.request)

    let {summaries: stats} = useSummaries(['datatype'], dname)
    let get_stat = (dt, what) => get(stats, `datatype.${dt}.${what}`, 0)
    let dts = [2, 1, 0, 3, 13, 16, 19]
    let rows = dts
      .filter(dt => get_stat(dt, 'total'))
      .map(dt => {
        return (
          <Table.Row key={dt}>
            <Table.Cell>
              <DatatypeDescription datatype={dt} />
            </Table.Cell>
            <Table.Cell>
              <Link
                classname="tree"
                tabname="list"
                query={{subdomains: true, types: itypes.datatypeMap[dt]}}
              >
                {formatNumber(get_stat(dt, 'total'))}
              </Link>
            </Table.Cell>
          </Table.Row>
        )
      })
    if (rows.length == 0) {
      return null
    }
    return (
      <DashSegment header={i18n.get('inventory')}>
        <Table definition compact>
          <Table.Body>{rows}</Table.Body>
        </Table>
      </DashSegment>
    )
  },
  align: 'right',
  acl: 'g:admin',
  datatypes: ['domain'],
}
